import React, { useState } from 'react'; // eslint-disable-line

/* Custom Hooks */
import { useDispatch } from 'react-redux';

/* Actions */
import { paymentActions } from '../../../../../../store/payments/actions';

export const useStripeInfo = () => {
  const dispatch = useDispatch();
  const [buyerName, setBuyerName] = useState<string>('');
  const [cardElementComplete, setCardElementComplete] =
    useState<boolean>(false);
  const [cardHolderComplete, setCardHolderComplete] = useState<boolean>(false);

  const intentPayment = () => {
    dispatch(paymentActions.paymentIntentRequestAction({}));
  };

  return {
    states: {
      buyerName,
      setBuyerName,
      cardElementComplete,
      setCardElementComplete,
      cardHolderComplete,
      setCardHolderComplete,
    },
    actions: { intentPayment },
  };
};
